import React from 'react'
//CSS
import styles from './Card.module.css';
//Components
import Button from '../../Utils/Button/Button';
import ProgressBar from '../../Utils/ProgressBar/ProgressBar';
import { AreaDisplayInfo } from '../../../Types/AreaDisplayInfo/AreaDisplayInfo';
import { Link, useNavigate } from 'react-router-dom';
import { SetArchivedEvaluateAreaRequest } from '../../../Types/Evaluate/SetArchivedEvaluateAreaRequest';
import { toast } from 'react-toastify';
import { useAppDispatch } from '../../../Redux/Store/Store';
import { SetArchivedEvaluateAreaById } from '../../../Redux/Store/Slices/area';
import { GetGradeColour } from '../../../Data/ColourData';
import Badges from '../../Utils/Badges/Badges';
import Tooltip from "../../Utils/Tooltip/Tooltip";
import CompletionStatus from '../../Utils/CompletionStatus/CompletionStatus';
import EditableInput from '../../Utils/EditableInput/EditableInput';
import ToggleSlider from '../../Utils/ToggleSlider/ToggleSlider';
import { useWorkflowContext } from '../../../Hooks/useWorkflowContext';
import { getProductTypePathSegment, getProductTypeName, ProductType } from '../../../Types/ProductType';
import DropDownList from '../../Utils/DropDownList/DropDownList';
import { formatUkDateSafe } from '../../../Helpers/Dates';
import ExportButton from '../../Utils/ExportButton/ExportButton';
type CardProps = {
    areaDisplayInfo: AreaDisplayInfo,
    url: string,
    editHandler?: () => void,
    archived: boolean,
    template: boolean,
    toggleArchiveHandler?: () => void;
    toggleDisabledHandler?: () => void;
    titleChangedHandler?: (newValue: string) => void;
    productTypeChanged?: (type: ProductType, templateId: string) => void;
    showToggleSlider?: boolean;
    /** Bulk selection on list pages (e.g. Evaluate active). */
    selectable?: boolean;
    selected?: boolean;
    onToggleSelect?: (id: string) => void;
    /** Hide per-card export when the list page provides bulk export. */
    hideExportButton?: boolean;
    /** Opens the list-page bulk export wizard with this card pre-selected. */
    onCardExport?: () => void;
}


const Card = ({
    areaDisplayInfo,
    url,
    archived,
    template,
    toggleArchiveHandler,
    toggleDisabledHandler,
    titleChangedHandler,
    showToggleSlider,
    productTypeChanged,
    selectable,
    selected,
    onToggleSelect,
    hideExportButton,
    onCardExport,
}: CardProps) => {
    const {
        id,
        title,
        dueDate,
        status,
        participantCount,
        groups,
        roles,
        organisations,
        departments,
        percentage,
        canArchive,
        canExport,
        canView,
        disabled,
        productType,
        ownerName,
        observee,
        individual,
    } = areaDisplayInfo;

    const { getWorkflowPath, isAdminContext } = useWorkflowContext();

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const archiveAreaByIdHandler = async () => {
        if(toggleArchiveHandler){
            toggleArchiveHandler();
            return;
        }

        try {

            let body : SetArchivedEvaluateAreaRequest = {
                areaId: id,
                archived: false
            };
            
            if (archived) {
                body.archived = false;
                dispatch(SetArchivedEvaluateAreaById(body));
                toast.success(`${title} area has been successfully unarchived.`)
            } else {
                body.archived = true;
                dispatch(SetArchivedEvaluateAreaById(body));
                toast.success(`${title} area has been successfully archived.`)
            }

        } catch (error) {
            console.error(error);
            toast.error(`Evaluate area archive status failed to set. Error: ${error}`)
        }
    }

    const handleToggleConfirm = async (newState: boolean) => {
        if (toggleDisabledHandler) {
            await toggleDisabledHandler();
        }
    }

    const completeSummary = async () => {
        if(!archived) {
            // For evaluate areas, navigate to the first criteria item
            if (!template) {
                // Navigate to the area overview, which will auto-navigate to first criteria
                navigate(url);
            } else {
                // For templates, use the existing URL
                navigate(url);
            }
        }
    }

    const summaryButtonMessage = canView? `Cannot ${percentage < 100 ? `Complete ${template? "Template" : "Diagnostic"}` : `Edit ${template? "Template" : "Diagnostic"}`} while archived` : `Your role means that you cannot view the content of this diagnostic`
    const observeeDisplayName = (observee || individual || '').trim();

    const supportsQuestionnaireExport =
        !template &&
        (productType === undefined ||
            productType === ProductType.Evaluate ||
            productType === ProductType.Enquire ||
            productType === ProductType.Develop);

    const handleSelectChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation();
        if (!canExport || !onToggleSelect) return;
        onToggleSelect(id);
    };

    return (
        <div
            className={`${styles.container} ${selectable ? styles.containerSelectable : ""} ${
                selected ? styles.containerSelected : ""
            }`}
        >
            {selectable && (
                <label className={styles.selectWrap}>
                    <input
                        type="checkbox"
                        className={styles.selectCheckbox}
                        checked={!!selected}
                        disabled={!canExport}
                        onChange={handleSelectChange}
                        aria-label={`Select ${title}`}
                    />
                </label>
            )}
            {/*<div className={styles.statusContainer}>
                    
                        {percentage === 100 ? (
                            <CompletionStatus status="Complete" />
                        ) : percentage === 0 ? (
                            <CompletionStatus status="Incomplete" />
                        ) : <CompletionStatus status="In Progress" />}
            </div>*/}
            <div className={styles.footer}>
                <div className={styles.footerLeft}>
                    <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
                        {
                            titleChangedHandler ? 
                            <EditableInput value={title} onChange={titleChangedHandler} /> 
                            : 
                            <h5 style={template? {paddingBottom: "0px", marginBottom: "4px"} : {}}>{title}</h5>
                        }
                        {template && productType != null && (
                            <p style={{fontSize: '0.8rem', color: '#6B7280', margin: 0, fontWeight: 500}}>
                                {getProductTypeName(productType)}
                            </p>
                        )}
                    </div>
                </div>
                <div className={styles.footerRight}>

                    {/*productTypeChanged && 
                        <DropDownList onChange={(x) => productTypeChanged(x.value as ProductType, id)} value={Number(productType)} placeholder={''} data={[{
                            text: 'Evaluate', value: ProductType.Evaluate,
                            colour: undefined,
                            textColour: undefined
                        }, {
                            text: 'Enquire', value: ProductType.Enquire,
                            colour: undefined,
                            textColour: undefined
                        }]}></DropDownList>
                    */}

                    {showToggleSlider && (
                        <ToggleSlider
                            isOn={!disabled}
                            onToggle={() => {}} // Handled by onConfirmAction
                            onConfirmAction={handleToggleConfirm}
                            size="medium"
                            confirmTitle={disabled ? "Enable Template" : "Disable Template"}
                            confirmMessage={disabled 
                                ? `Are you sure you want to enable "${title}"? Users will be able to import this template.`
                                : `Are you sure you want to disable "${title}"? Users will no longer be able to import this template.`
                            }
                            confirmText={disabled ? "Enable" : "Disable"}
                            cancelText="Cancel"
                            disabled={!canArchive}
                        />
                    )}

                    {template && productType !== undefined && isAdminContext === false &&
                        <Tooltip text={`Your role means that you cannot mandate this template`} align={'top'} sideAlign='left' disabled={canArchive}>
                            <Button disabled={!canArchive} size="Small" colour="#FFF" textColour="#000" border={canArchive? `rgba(0,0,0,0.2)` : "#e0e0e0"} clickHandler={() => navigate(getWorkflowPath(id, title, 'mandate-template', getProductTypePathSegment(productType)))}>
                                Mandate
                            </Button>
                        </Tooltip>}


                    <Tooltip text={`Your role means that you cannot archive this item`} align={'top'} sideAlign='left' disabled={canArchive}>
                            <Button disabled={!canArchive} size="Small" colour="#FFF" textColour="#000" border={canArchive? `rgba(0,0,0,0.2)` : "#e0e0e0"} clickHandler={archiveAreaByIdHandler}>
                                {archived ? "Unarchive" : "Archive"}
                            </Button>
                        </Tooltip>

                    {supportsQuestionnaireExport && hideExportButton && onCardExport && (
                        <Tooltip text={`Your role means that you cannot export this item`} align={'top'} sideAlign='left' disabled={canExport}>
                            <Button
                                disabled={!canExport}
                                size="Small"
                                colour="#FFF"
                                textColour="#000"
                                border={canExport ? `rgba(0,0,0,0.2)` : "#e0e0e0"}
                                clickHandler={onCardExport}
                            >
                                Export
                            </Button>
                        </Tooltip>
                    )}

                    {supportsQuestionnaireExport && !hideExportButton && (
                        <Tooltip text={`Your role means that you cannot export this item`} align={'top'} sideAlign='left' disabled={canExport}>
                            <span>
                                <ExportButton
                                    areaIds={id}
                                    areaDisplayInfos={[areaDisplayInfo]}
                                    label="Export"
                                    size="Small"
                                    disabled={!canExport}
                                    productName={
                                      productType !== undefined
                                        ? getProductTypeName(productType)
                                        : "Evaluate"
                                    }
                                />
                            </span>
                        </Tooltip>
                    )}

                    <Tooltip text={summaryButtonMessage} align={'top'} sideAlign='left' disabled={!archived && canView}>
                            <Button disabled={archived || !canView} clickHandler={() => completeSummary()} size="Small" colour="#FFF" textColour="#000" border="rgba(0,0,0,0.2)" style={{minWidth: '100px'}}>
                                {percentage < 100 ? `Complete ${template? "Template" : "Diagnostic"}` : `Edit ${template? "Template" : "Diagnostic"}`}
                            </Button>
                    </Tooltip>
                </div>
            </div>

             
            {template? <></> :
            <div className={styles.infoContainer}>
                <div className={styles.info}>
                    <p>Due: {formatUkDateSafe(dueDate)}</p>

                    <p>Role: {roles?.join(", ")}</p>
                    {ownerName && (
                        <p>{productType === ProductType.Develop ? `Completed By (Owner): ${ownerName}` : `Owner: ${ownerName}`}</p>
                    )}
                
                    {groups?.length > 0 &&
                    <p>Group: {groups?.join(", ")}</p>
                    }
                        
                    {organisations?.length > 0 &&
                        <p>Organisation: {organisations?.join(", ")}</p>
                    }
                    {departments?.length > 0 &&
                        <p>Department: {departments?.join(", ")}</p>
                    }

                    {productType === ProductType.Develop && observeeDisplayName && (
                        <p>Completed For: {observeeDisplayName}</p>
                    )}

                    <p className={styles.participants}>{participantCount} {participantCount === 1 ? 'Participant' : 'Participants'}</p>

                    <p>Type: {productType != null ? ProductType[productType as ProductType] : '—'}</p>
                </div>
            </div>
            }
            <div className={styles.status}>
                <ProgressBar percentage={percentage} />
                <p className={styles.percentage}>{`${percentage}%`}</p>
            </div>
        </div>
    )
}

export default Card